export default "__VITE_ASSET__8BAuw$8F__"